import { AccountCommands, initAccountsSlice } from '@skynet/data-shared-accounts';
import { actionEsOnMessage } from '@skynet/data-ws-es';
import { resetStore } from 'src/store/actions';
import { apiKeysAction } from 'src/store/trading/apiKeys/actions';

const reducer = initAccountsSlice({
  prefix: 'trading',
  sliceName: 'accounts',
  commands: AccountCommands,
  messages: actionEsOnMessage,
  resetAction: resetStore,
  extraReducers: (builder) => {
    builder.addCase(apiKeysAction.listen, (state, action) => {
      const { isInitCall } = action.meta;
      if (isInitCall) {
        state.requestStatus = 'pending';
      }
    });
  },
});

export default reducer;
